// ============================================================================
// backNavigation.ts — ЕДИНЫЙ источник действия «Назад» (SSoT/SRP).
//
// Детерминированный приоритет:
//   1) открытые МОДАЛЬНЫЕ окна — закрывается ВЕРХНЕЕ (окно → родитель);
//   2) уровень навигации оболочки (navBack: объект→список→раздел→рабочий стол);
//   3) действия нет (рабочий стол / корень).
//
// Кнопку «←» рисует ЕДИНЫЙ компонент BackButton (в шапке окна и в шапке
// оболочки). Модальное окно вызывает СВОЙ onClose (закрыть себя = вернуться к
// родителю); шапка оболочки — goBack() (учитывает приоритет окон и уровней).
// ============================================================================

import { create } from 'zustand';

interface OpenWindow {
  id: string;
  close: () => void;
}

interface BackState {
  /** Открытые модальные окна в порядке открытия (верхнее — последнее). */
  windows: OpenWindow[];
  /** Навигационный «назад» активного экрана (оболочка Предприятия). */
  navBack: (() => void) | null;
  registerWindow: (id: string, close: () => void) => void;
  unregisterWindow: (id: string) => void;
  setNavBack: (fn: (() => void) | null) => void;
  goBack: () => void;
}

export const useBackStore = create<BackState>()((set, get) => ({
  windows: [],
  navBack: null,
  registerWindow: (id, close) => set((s) => ({
    // Повторная регистрация того же окна — наверх (порядок = порядок открытия).
    windows: [...s.windows.filter((w) => w.id !== id), { id, close }],
  })),
  unregisterWindow: (id) => set((s) => ({ windows: s.windows.filter((w) => w.id !== id) })),
  setNavBack: (fn) => set({ navBack: fn }),
  goBack: () => {
    const { windows, navBack } = get();
    const top = windows[windows.length - 1];
    if (top) {
      top.close();
      return;
    }
    if (navBack) navBack();
  },
}));
